import LegacyBreadcrumbItem from './LegacyBreadcrumbItem';

export * from './LegacyBreadcrumbItem';

export default LegacyBreadcrumbItem;
